import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Tabs,
  Tab,
  Typography,
  styled,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import IntegrationsSettings from './IntegrationsSettings';
import { OrganizationSettings } from './OrganizationSettings';
import { ContactForm } from './ContactForm';
import { useAuthStore } from '../../store/authStore';

interface SettingsDialogProps {
  open: boolean;
  onClose: () => void;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const DialogHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 3),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && <div style={{ padding: 24 }}>{children}</div>}
    </div>
  );
};

const SettingsDialog: React.FC<SettingsDialogProps> = ({ open, onClose }) => {
  const { user } = useAuthStore();
  const [tabValue, setTabValue] = useState(0);
  
  const isAdmin = user?.organizationRole === 'admin' || user?.organizationRole === 'owner';
  

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: { height: '80vh', maxHeight: 800 }
      }}
    >
      <DialogHeader>
        <Typography variant="h6">Settings</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogHeader>
      
      <DialogContent style={{ padding: 0, display: 'flex', flexDirection: 'column' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          style={{ borderBottom: '1px solid rgba(0,0,0,0.12)' }}
        >
          {/* <Tab label="General" /> */}
          <Tab label="Integrations" />
          {/* <Tab label="Appearance" /> */}
          {/* <Tab label="Notifications" /> */}
          {isAdmin && <Tab label="Organization" />}
          <Tab label="Contact Us" />
        </Tabs>
        
        <div style={{ flex: 1, overflow: 'auto' }}>
          {/* <TabPanel value={tabValue} index={0}>
            <Typography variant="body1" color="text.secondary">
              General settings coming soon...
            </Typography>
          </TabPanel> */}
          
          <TabPanel value={tabValue} index={0}>
            <IntegrationsSettings />
          </TabPanel>
          
          {/* <TabPanel value={tabValue} index={2}>
            <Typography variant="body1" color="text.secondary">
              Appearance settings coming soon...
            </Typography>
          </TabPanel> */}
          
          {/* <TabPanel value={tabValue} index={3}>
            <Typography variant="body1" color="text.secondary">
              Notification settings coming soon...
            </Typography>
          </TabPanel> */}
          
          {isAdmin && (
            <TabPanel value={tabValue} index={1}>
              <OrganizationSettings />
            </TabPanel>
          )}
          
          <TabPanel value={tabValue} index={isAdmin ? 2 : 1}>
            <ContactForm />
          </TabPanel>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsDialog;